<template>
  <div class="order-confirmation flux-xs-sm" v-if="chosenQuote">
    <b-card tag="article" class="container mb-7 py-7">
      <div class="row">
        <div
          class="order-confirmation-content-wrapper col-12 col-md-10 col-lg-6 px-lg-7 mx-0 mx-auto"
        >
          <section>
            <div v-if="isGeneric">
              <h2
                class="text-primary font-weight-bold pb-3"
                v-dynamic-content:confirmation_thanks_title_generic
              />
              <p class="pb-5" v-dynamic-content:confirmation_thanks_for_your_order_generic />
            </div>

            <div v-else>
              <h2
                class="text-primary font-weight-bold pb-3"
                v-dynamic-content:summary_order_title
              />
              <p class="pb-5" v-dynamic-content:summary_order_text />
              <h2
                class="text-primary font-weight-bold pb-3"
                v-dynamic-content:confirmation_nextsteps_title
              />
              <p class="pb-5" v-dynamic-content:confirmation_nextsteps_text />
            </div>

            <template v-if="!isGeneric">
              <div v-if="content.summary_order_installation_steps_title">
                <h2 class="text-primary font-weight-bold pb-3">
                  {{ content.summary_order_installation_steps_title }}
                </h2>
                <ol>
                  <li v-for="step in installationSteps" :key="step">{{ step }}</li>
                </ol>
              </div>
              <steps-icons v-else></steps-icons>
            </template>

            <div
              v-if="!isGeneric"
              class="collapse-titles d-flex justify-content-between flex-wrap align-items-end"
            >
              <order-summary-card-installation></order-summary-card-installation>
              <section class="section w-100">
                <div
                  class="collapse-item d-flex justify-items-between align-items-center mb-5"
                  v-b-toggle.order
                >
                  <h2 class="text-primary font-weight-bold m-0 ml-2">
                    {{ content.summary_order_title }}
                  </h2>
                </div>
                <b-collapse id="order" accordion="order-info">
                  <order-summary-card-confirmation
                    :quote="chosenQuote"
                    :productsServices="getProductsServices()"
                    :showProductsServices="showProductsServices()"
                  ></order-summary-card-confirmation>
                  <b-button
                    @click="goToDetails"
                    class="mb-7"
                    variant="secondary"
                    v-dynamic-content:pv_package_cta_details
                  ></b-button>
                </b-collapse>
              </section>
            </div>

            <div v-else>
              <order-summary-card-confirmation
                :quote="chosenQuote"
                :productsServices="getProductsServices()"
                :showProductsServices="showProductsServices()"
              ></order-summary-card-confirmation>
            </div>
            <backto-top-button></backto-top-button>
          </section>
        </div>
      </div>
    </b-card>
    <ContentLow />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BacktoTopButton from '@/components/main/scroll/BacktoTopButton'
import OrderSummaryCardConfirmation from './OrderSummaryCardConfirmation'
import OrderSummaryCardInstallation from './OrderSummaryCardInstallation'
import ContentLow from '../parts/ContentLow'
import StepsIcons from '../parts/StepsIcons'

export default {
  name: 'Order',
  mixins: [],
  components: {
    ContentLow,
    StepsIcons,
    OrderSummaryCardConfirmation,
    OrderSummaryCardInstallation,
    BacktoTopButton,
  },
  computed: {
    ...mapGetters(['isGeneric']),
    installationSteps() {
      const content = this.$store.getters.content.summary_order_installation_steps
      return content && content.trim().split('\n')
    },
  },
  methods: {
    goToDetails() {
      this.$router.push({ name: 'OrderDetail' })
    },
    getAddons() {
      const chosenAddonsAr = []
      if (this.iquote && this.iquote.chosenAddons) {
        this.iquote.chosenAddons.forEach((chosenAddonId) => {
          const addonObj = this.chosenQuote.addons.find(
            (addon) => addon.defaultCode === chosenAddonId
          )
          chosenAddonsAr.push(addonObj)
        })
      }
      return chosenAddonsAr
    },
    getProductsServices() {
      return this.getAddons().map(({ name, defaultCode, priceInclVAT }) => ({
        text: { title: this.content[`translation_addon_${defaultCode}_title`] || name },
        priceInclVAT,
        productId: defaultCode,
      }))
    },
    showProductsServices() {
      return this.getAddons().length > 0
    },
  },
  mounted() {
    this.$store.dispatch('putActivity', {
      activity: 'VIEW_ORDER',
      quoteId: this.chosenQuote.id,
    })

    window.dataLayer.push({
      event: 'page_load',
      element: 'system receipt',
      quote_type: this.$store.getters.quoteType,
      element_detail: this.chosenQuote.id
    })
  },
}
</script>
